import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { Reservation } from '@mews-commander/data-access';
import { getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks/customers';

interface StateProps {
    booker?: string;
}

interface OwnProps {
    reservation: Reservation;
    serviceId: string;
}

export const connectSpaceOrderLabel = connect<StateProps, null, OwnProps, ApplicationState>(
    createStructuredSelector({
        booker: (state: ApplicationState, { reservation }: OwnProps) =>
            // @ts-expect-error
            getCustomerFullName(state, { id: reservation.bookerId }),
    })
);
